// Lazy loader for sweetalert2 — replaces the eager Vue.use(VueSweetalert2) in main.js so the ~40KB lib
// + its CSS stay OUT of the initial bundle (loaded on the first alert instead, on every page).
//
// IMPORTANT: we lazy-load `vue-sweetalert2` (NOT `sweetalert2` directly). vue-sweetalert2 bundles its own
// nested sweetalert2 **v11** (the `icon:` API the app uses, e.g. icon:'error' → the red X). The repo also
// has a stale top-level `sweetalert2` **v8** (`type:` API, no `icon`) that no component imports — importing
// `sweetalert2` directly would pull v8 and silently drop the icon. Deferring the real Vue.use keeps exact
// prior behavior (v11 + `icon:` works) while moving it off the initial bundle.
//
// App-wide only `.fire` is used (~1975 calls), across this.$swal({...}), this.$swal.fire({...}), and the
// bare global Swal.fire({...}) in ~11 components (Contact, singpassLogin, …) — those were BROKEN before
// (window.Swal was never set), so the window.Swal stub below both enables lazy-load AND fixes them. After
// the first alert, Vue.prototype.$swal + window.Swal are the real v11 Swal, so later calls are synchronous.
import Vue from "vue";

let installPromise = null;

function ensureSwal() {
  if (!installPromise) {
    installPromise = Promise.all([
      import(/* webpackChunkName: "sweetalert2" */ "vue-sweetalert2"),
      import(/* webpackChunkName: "sweetalert2" */ "sweetalert2/dist/sweetalert2.min.css"),
    ]).then(function (mods) {
      var VueSweetalert2 = mods[0].default || mods[0];
      Vue.use(VueSweetalert2);             // installs the REAL $swal (vue-sweetalert2 + nested v11 Swal)
      var realSwal = Vue.prototype.$swal;  // the swalFunction (callable + has .fire)
      window.Swal = realSwal;              // real global for bare `Swal.fire(...)` sites (sync hereafter)
      return realSwal;
    });
  }
  return installPromise;
}

// $swal(...) and $swal.fire(...) both resolve to Swal.fire's promise (so .then()/await keep working).
function lazyFire() {
  var args = arguments;
  return ensureSwal().then(function (Swal) {
    return Swal.fire.apply(Swal, args);
  });
}
lazyFire.fire = lazyFire;

export default lazyFire;
